import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsDataManagerGettingStartedEntryPoint } from '@jira/spa-apps__assets-data-manager-getting-started-page/src/assetsDataManagerGettingStartedEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsDataManagerGettingStartedRoute } from '@jira/router-routes__assets-app-data-manager-routes/src/assetsDataManagerGettingStartedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsDataManagerGettingStartedPageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerGettingStartedEntryPoint,
});

export const assetsDataManagerGettingStartedRouteEntry: Route = createEntry(
	assetsDataManagerGettingStartedRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		perfMetricKey: 'assets-data-manager-getting-started',
		ufoName: 'assets-data-manager-getting-started',
		pageId: () => 'spa-apps/assets-data-manager-getting-started',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],
		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerGettingStartedPageEntryPoint
				: undefined;
		},
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_data_manager_jira_spa') ? undefined : ErrorPagesNotFound,
		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_GETTING_STARTED_PAGE),
				teamName: 'Aurum',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
